import styled from 'styled-components';
import { CHATS_HEADER_HEIGHT } from '../styles';

export const Base = styled.div`
	// layout
	height: ${CHATS_HEADER_HEIGHT}px;
	padding-left: 14px;
	padding-right: 4px;
	display: flex;
	align-items: center;

	// style
	background: transparent;
	justify-content: space-between;
`;

export const Label = styled.div`
	font-size: 14px;
	font-family: 'Inter', sans-serif;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	user-select: none;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 100%;
`;

export const ButtonGroup = styled.div`
	display: flex;
	gap: 0px;
	align-items: center;
`;

export const Button = styled.button`
	background: transparent;
	border: none;
	padding-top: 3px;
	padding-left: 3px;
	border-radius: 6px;
	width: 24px;
	height: 24px;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const NewChatButton = styled.button`
	padding: 1px 8px;
	height: 22px;
	background: transparent;
	border: 2px solid ${({ theme }) => theme.gray[200]};
	border-radius: 12px;
	margin-right: 2px;
	color: ${({ theme }) => theme.gray[600]};
	font-size: 12px;
	font-weight: 600;
	white-space: nowrap;
	flex-shrink: 0;
	transition: background 0.15s ease;

	&:hover {
		background: ${({ theme }) => theme.gray[200]};
		color: ${({ theme }) => theme.gray[800]};
	}
	&:active {
		background: ${({ theme }) => theme.gray[400]};
		color: ${({ theme }) => theme.gray[800]};
	}
`;

// nested buttons are not allowed so we have a separate style for the dropdown trigger
export const DropdownTrigger = styled.div`
	background: transparent;
	border: none;
	border-radius: 6px;
	padding-left: 1px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;
